import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { TagControlState } from './TagControl.type';
import { getTagControlListThunk } from './TagControl.thunk';

const SLICE_NAME = 'tagControl';

const initialState: TagControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const tagControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setTagControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getTagControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(getTagControlListThunk.fulfilled, (state, { payload }) => {
      const { data, pagination } = payload;
      state.isLoading = false;
      state.items = data;
      state.pagination = {
        currentPage: pagination.current_page,
        lastPage: pagination.last_page,
        perPage: pagination.per_page,
        from: pagination.from,
        to: pagination.to,
        total: pagination.total,
      };
    });
    builder.addCase(getTagControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const getTagControlList = (state: RootState) => state.tagControl.items;
export const getTagControlListPagination = (state: RootState) => state.tagControl.pagination;

export const {
  setTagControlList
} = tagControlSlice.actions;


export default tagControlSlice.reducer;
